import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender } from './Icon';

const ShapeCalloutIcon = forwardRef<SVGSVGElement, ComponentProps<typeof Icon>>(
  (props, ref) => (
    <Icon data-testid="shapeCallout" ref={ref} {...props}>
      <path d="M20.37,2.87H9.52a.76.76,0,0,0-.75.75V14.17l-4.4,4.4V15.49a.75.75,0,0,0-1.5,0v4.89a.77.77,0,0,0,0,.15.75.75,0,0,0,.58.58l.15,0H8.51a.75.75,0,1,0,0-1.5H5.43l4.4-4.4H20.37a.75.75,0,0,0,.75-.75V3.62A.75.75,0,0,0,20.37,2.87Zm-.75,10.86H10.27V4.37h9.35Z" />
    </Icon>
  ),
) as IconWithRender;

ShapeCalloutIcon.displayName = 'ShapeCalloutIcon';
ShapeCalloutIcon.renderIcon = (props) => <ShapeCalloutIcon {...props} />;
export default ShapeCalloutIcon;
